@if (itemsWithJsonData.length) {
    <app-table
        [items]="itemsWithJsonData"
        [columns]="columns"
        translatePrefix="form.rvd."
        [hideCheckboxes]="true"
        [resource]="resource"
        (detailCallback)="detail($event)"
        (deleteCallbackWithEvent)="delete($event)"
    >
        <ng-template pTemplate="printHeader"></ng-template>
        <ng-template pTemplate="print" let-item="item">
            <app-button
                [text]="true"
                styleClass="p-button-set-icon-size"
                icon="pi-print"
                (clickEvent)="print(item)"
            ></app-button>
        </ng-template>

        <ng-template pTemplate="copyHeader"></ng-template>
        <ng-template pTemplate="copy" let-item="item">
            <app-button
                [text]="true"
                styleClass="p-button-set-icon-size"
                icon="pi-copy"
                (clickEvent)="copy(item)"
            ></app-button>
        </ng-template>

        <ng-template pTemplate="mobility" let-item="item">
            <span
                [pTooltip]="('form.rvd.mobilityOptions.' + item.data.mobility) | translate"
            >{{ item.data.mobility }}</span>
        </ng-template>

        <ng-template pTemplate="activity" let-item="item">
            <span
                [pTooltip]="('form.rvd.activityOptions.' + item.data.activity) | translate"
            >{{ item.data.activity }}</span>
        </ng-template>

        <ng-template pTemplate="incontinence" let-item="item">
            <span
                [pTooltip]="('form.rvd.incontinenceOptions.' + item.data.incontinence) | translate"
            >{{ item.data.incontinence }}</span>
        </ng-template>

        <ng-template pTemplate="bodyCondition" let-item="item">
            <span
                [pTooltip]="('form.rvd.bodyConditionOptions.' + item.data.bodyCondition) | translate"
            >{{ item.data.bodyCondition }}</span>
        </ng-template>

        <ng-template pTemplate="mentalState" let-item="item">
            <span
                [pTooltip]="('form.rvd.mentalStateOptions.' + item.data.mentalState) | translate"
            >{{ item.data.mentalState }}</span>
        </ng-template>

    </app-table>
}
